<script setup lang="ts">
import { IconMarquee2 } from '@tabler/icons-vue';

import type { Product } from '../../shared/models/product.ts';

defineProps<{ product: Product }>();
</script>

<template>
    <span
        v-if="product.iconHtml"
        v-html="product.iconHtml"
        class="ProductIcon no-shrink"
        style="
            display: inline-flex;
            flex-direction: column;
            justify-content: center;
            width: 1.2em;
            height: 1.2em;
            vertical-align: -0.25em;
        "
    />

    <IconMarquee2 v-else class="icon" style="width: 1.2em; height: 1.2em; margin: 0" />
</template>

<style scoped>
.ProductIcon :deep(img),
.ProductIcon :deep(svg) {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>
